import {Inject, Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DOCUMENT} from '@angular/common';
import {isEmpty} from 'lodash';
@Injectable()
export class LocationService {

  constructor(
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private doc: Document) {}

  handleHref(url:string){
    let paramString = '';
      if(!isEmpty(this.route.snapshot.queryParams)){
        const params = this.route.snapshot.queryParams;
        paramString += '?'+Object.keys(params).map((x)=>`${x}=${params[x]}`).join('&');
      }
      this.doc.location.href = url + paramString;
  }
}
